module.exports = __webpack_public_path__ + "img/z-solution-icon1.497d5217.png";